import { render, staticRenderFns } from "./profiles.page.vue?vue&type=template&id=4a5d4431"
import script from "./profiles.page.vue?vue&type=script&lang=ts"
export * from "./profiles.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports